// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerCarteApi } from "../../services/Api/CustomerCartApi"
import { getCustomerCartList ,getErrors} from "../reducers/CustomerCartReducer"


// Watchers
function* customerCartSaga() {
	yield takeEvery("customerCart/getCustomerCart", getCart)
}

// Sagas
function* getCart(action) {

	try {
		const getCustomerCart = yield call(getCustomerCarteApi, action.payload)
		
		if (getCustomerCart.request.status === 200) {
            // console.log(getCustomerCart);
			yield put(getCustomerCartList(getCustomerCart))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
      
        // console.log(error);
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerCartSaga)])
}
